import { render } from "./LeadGen.vue?vue&type=template&id=0311ca82"
import script from "./LeadGen.vue?vue&type=script&lang=js"
export * from "./LeadGen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__